import React, { useState, useEffect } from 'react';
import { Box, Fade } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import CircularProgress from '@mui/material/CircularProgress';

import Logo from 'src/components/Logo';

const useStyles = makeStyles(() => ({
  box: {
    // backgroundColor: colors.common.white,
    minHeight: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}));

const PagePreloader = (props) => {
  const classes = useStyles();

  return (
    <Box className={classes.box} {...props}>
      <CircularProgress />
    </Box>
  );
};

export function PagePreloaderWithLogo() {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
  }, []);

  return (
    <Box className={classes.box}>
      <Fade
        in={loading}
        style={{
          transitionDelay: loading ? '800ms' : '0ms'
        }}
        unmountOnExit
      >
        <CircularProgress variant="indeterminate" size={100} thickness={1} />
      </Fade>
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Logo />
      </Box>
    </Box>
  );
}

export default PagePreloader;
